import { Component, OnInit,ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import * as snippet from 'app/main/tables/datatables/datatables.snippetcode';
import { finalize } from 'rxjs/operators';
import { Subject, BehaviorSubject } from "rxjs";
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { ProService } from '@pro/services/pro.service';
import { NotificationService } from '@core/services/notification.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-old-patient-billing',
  templateUrl: './old-patient-billing.component.html',
  styleUrls: ['./old-patient-billing.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OldPatientBillingComponent implements OnInit {

  public search_text: any;
  public basicSelectedOption: number = 500;
  curPage: any;
  rowCount: any;
  pageSize: any;
  totalCount: number;
  public mySearchControl = new FormControl();
  public filterLoading = new BehaviorSubject(false);
  isShown: boolean = false;
  pageHeading: any;
  backendValidations: any;
  public loading = new BehaviorSubject(false);

  toggleShow() {
    this.isShown = !this.isShown;
  }

    oldPatientFilterForm : FormGroup = this._formBuilder.group({
      fpatient_unique_id: [null],
      fpatient_name: [null]
    });

    get fpatient_unique_id() { return this.oldPatientFilterForm.get('oldPatientFilterForm'); }
    get fpatient_name() { return this.oldPatientFilterForm.get('fpatient_name'); }
    
    // due pending form validation
    duePendingForm : FormGroup = this._formBuilder.group({
      no_of_days_medicine_pro : ["", [Validators.required, Validators.pattern('^(?!.*  ).+')]],
      remarks : ["", [Validators.required, Validators.maxLength(500),Validators.pattern('^(?!.*  ).+')]]
    });

    get no_of_days_medicine_pro() { return this.duePendingForm.get('no_of_days_medicine_pro')};
    get remarks() { return this.duePendingForm.get('remarks')};

    errorMessages = {
      no_of_days_medicine_pro: [{ type: 'required', message: 'The No of Days Medicine Field is required'}],
      remarks: [{ type: 'required', message: 'The Remarks Field is required'}],
    };

    submitDuePendingForm(){
      this.duePendingForm.markAllAsTouched();
      if (this.duePendingForm.valid) {
        this.duePendingForm.value.patient_id = this.selectedPatient.patient_id;
        this.loading.next(true);
        this._service.addFeedBack(this.duePendingForm.value)
        .pipe(finalize(() => this.loading.next(false)))
        .subscribe(res => {
            if (res['status'] == 'success') {
              this.notifyService.showSuccess(res['message'], res['title']);
              this.closeDuePendingForm();
            } else if (res['status'] == 'errors') {
              for (var key in res['errorValidations']) {
                let backendValidations = res["errorValidations"];
                this.backendValidations = backendValidations;
                this.duePendingForm.controls[key].setErrors({ serverValidationError: true });
              }
            } else if (res['status'] == 'error') {
              this.notifyService.showError(res['message'], res['title']);
            }
        }, err => {
          this.notifyService.showError(err['message'], err['title']);
        });
      }
    }

    closeDuePendingForm(){
      this.duePendingForm.reset();
      this.modalService.dismissAll();
    }
    // due pending form validation ends
    
    // Private
    private _unsubscribeAll: Subject<any>;
    private tempData = [];
  
    // public
    public rows: any;
    public selected = [];
    public kitchenSinkRows: any;
    public ColumnMode = ColumnMode;
    public expanded = {};
    public chkBoxSelected = [];
    public SelectionType = SelectionType;
    selectedPatient: any;

   public oldPatientsBillingData : any[] = [];

    @ViewChild(DatatableComponent) table: DatatableComponent;
    @ViewChild('tableRowDetails') tableRowDetails: any;
  
    // snippet code variables
    public _snippetCodeKitchenSink = snippet.snippetCodeKitchenSink;
    public _snippetCodeCustomCheckbox = snippet.snippetCodeCustomCheckbox;

  /**
   * Constructor
   */
  constructor(private modalService: NgbModal,
    private _formBuilder: FormBuilder,
    public _activatedRoute: ActivatedRoute,
    private notifyService: NotificationService,
    private _router: Router,
    private _service: ProService) { 
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.getOldPatientBilling();

    /* DataTable Search Filter */
    this.mySearchControl.valueChanges.pipe(debounceTime(500), distinctUntilChanged()
    ).subscribe(val => {
      this.search_text = this.mySearchControl.value;
      this.table.offset = 0;
      this.oldPatientFilterForm.value.page = 1;
      this.getOldPatientBilling();
    });
  }

  /* Get New Patient Billing Listing */
  getOldPatientBilling() {
    this.oldPatientFilterForm.value.perpage = this.basicSelectedOption;
    this.oldPatientFilterForm.value.fsearch_text = this.search_text;

    this._service.getOldPatientBilling(this.oldPatientFilterForm.value)
      .pipe(finalize(() => this.filterLoading.next(false)))
      .subscribe(res => {
        let data = res['data'];
        this.oldPatientsBillingData = data['oldPatientList'];
        this.totalCount = data['total'];
        this.curPage = data['page'];
      }, err => {
        this.notifyService.showError(err['message'], err['title']);
      });
  }

  /* Check atleast has one value in filter Form */
  checkFilterValidity() {
    if (this.oldPatientFilterForm.value.fpatient_unique_id || this.oldPatientFilterForm.value.fpatient_name) {
      return false;
    } else {
      return true;
    }
  }

  /* Redirect CaseSheet */
  caseSheet(patientId) {
    let link = environment.subdirUrl + '/pro/home/case-sheet/' + patientId;
    this._router.navigate([]).then(result => {  window.open(link, '_blank'); });
  }

  /* Apply Transfers Filter */
  applyFilter() {
    this.filterLoading.next(true);
    this.getOldPatientBilling();
  }

  /* Reset Filter */
  resetFilter() {
    this.oldPatientFilterForm.reset();
    this.getOldPatientBilling();
  }

  /* Manage Listing Limit */
  listingLimit($event) {
    this.basicSelectedOption = $event;
    this.oldPatientFilterForm.value.perpage = this.basicSelectedOption;
    this.oldPatientFilterForm.value.page = 1;
    this.getOldPatientBilling();
  }

  /* Paginate records */
  onFooterPage($event) {
    this.oldPatientFilterForm.value.page = $event.page;
    this.getOldPatientBilling();
  }

  modalOpen(modal) {
    this.modalService.open(modal, {
      windowClass: "modal",
      centered: true,
      backdrop:'static',
    });
  }

  // Due Pending Modal
  duePendingModal(modal, row) {
    this.selectedPatient = row;
    this.modalService.open(modal, {
      windowClass: "modal",
      centered: true,
      backdrop:'static',
    });
  }

  /* Redirect Update Billing */
  payDue(patientId) {
    let link = environment.subdirUrl + '/pro/home/pay-due-billing/' + patientId;
    this._router.navigate([]).then(result => {  window.open(link, '_blank'); });
  }
  
}
